import { Result, validatedApiCall } from '../api';
import { APIValidationError } from '../../types/api/api';
import { AssessoriesFilters } from './getAssessories';
import toQueryParams from '../../utils/toQueryParams';

export interface AssessoriaExport {
  content: string;
}

export type GetExportAssessoriaDTO = AssessoriesFilters;

export const getExportAssessoria = async (
  data: GetExportAssessoriaDTO,
): Promise<Result<AssessoriaExport, APIValidationError>> => {
  return validatedApiCall<AssessoriaExport>(
    `/api/assessories/exports/csv?${toQueryParams(
      data as unknown as Record<string, string>,
    )}`,
    {
      method: 'GET',
      auth: true,
    },
  );
};
